/** Identificações do Representante */
export interface ConfigEmpresaIdentificacaoRepresentante {
    id: number;
    nome: string;
}

export const identificacoRepresentanteNome: ConfigEmpresaIdentificacaoRepresentante = {id: 1, nome: 'Nome'};
export const identificacoRepresentanteNomeFantasia: ConfigEmpresaIdentificacaoRepresentante = {id: 2, nome: 'Fantasia'};

export const identificacoesRepresentante: ConfigEmpresaIdentificacaoRepresentante[] = [
    identificacoRepresentanteNome,
    identificacoRepresentanteNomeFantasia
];

/** Verifica se a identificação do Representante é por Nome */
export function isIdentificacaoRepresentanteNome(identificacao: number): boolean {
    if (!identificacao) {
        return false;
    }
    return identificacao === identificacoRepresentanteNome.id;
}

/** Verifica se a identificação do Representante é por Nome Fantasia */
export function isIdentificacaoRepresentanteNomeFantasia(identificacao: number): boolean {
    if (!identificacao) {
        return false;
    }
    return identificacao === identificacoRepresentanteNomeFantasia.id;
}

/** Retorna o nome primário do Representante conforme a identificação do representante pela empresa selecionada na configuração da Empresa */
export function createNomeRepresentante(identificacao: number, nome: string, nomeFantasia: string): string {
    // Nome
    if (isIdentificacaoRepresentanteNome(identificacao)) {
        return nome ?? '';
    }
    // Nome Fantasia
    if (isIdentificacaoRepresentanteNomeFantasia(identificacao)) {
        return nomeFantasia ?? '';
    }
    // Padrão Nome
    return nome ?? '';
}

/** Retorna o nome secundário do Representante conforme a identificação do representante pela empresa selecionada na configuração da Empresa */
export function createNomeSecundarioRepresentante(identificacao: number, nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null): string {
    let codigo = '';
    if (codigoIntegracaoErp) {
        codigo = `${codigoIntegracaoErp} - `;
    }

    // Nome Fantasia retorna o nome
    if (isIdentificacaoRepresentanteNomeFantasia(identificacao)) {
        return `${codigo}${nome ?? ''}`;
    }

    // Nome retorna o nome fantasia
    return `${codigo}${nomeFantasia ?? ''}`;
}
